import { MatDialog } from '@angular/material';
import { UsersService } from '@app/api/users.service';
import { LayoutUtilsService } from '@app/core/_base/crud';
import { Router } from '@angular/router';
import { CartProductService } from './../../../api/cartProduct.service';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { environment } from '@app/../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { AppCartModalChangeAddressComponent } from '../app-cart-modal-change-address/app-cart-modal-change-address.component';
import { OrderService, OrderHistoryService, VoucherService } from '@app/api/api';
import { UtilService } from '@app/services/util.service';
import { FormControl, FormGroup } from '@angular/forms';
import { AppOrderDetailAddProductComponent } from '../order/app-order-detail-add-product/app-order-detail-add-product.component';
import { forkJoin } from 'rxjs';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'meu-app-cart',
  templateUrl: './app-cart.component.html',
  styleUrls: ['./app-cart.component.scss'],
})
export class AppCartComponent implements OnInit {
  constructor(
    private cartProductService: CartProductService,
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router,
    private layoutUtilsService: LayoutUtilsService,
    private toastr: ToastrService,
    private userService: UsersService,
    private dialog: MatDialog,
    private orderService: OrderService,
    private orderHistoryService: OrderHistoryService,
    private voucherService: VoucherService
  ) {}

  suggestionKeyword: string = '';
  listProduct: any = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
  lstProductCart: any = [];
  environment: any = environment;
  checkAll: boolean = true;
  quantityProductChecked: any = 0;
  monePaid: any = 0;
  provisionalMoney: any = 0;
  shipMoney: any = 0;
  currency: any;
  lstMyAddress: any = [];
  addressDefault: any = '';
  addressId: any = '';
  vat: number = null;
  note: any = null;

  isPromotion: boolean = false;

  subStepForm = new FormGroup({
    order_id: new FormControl(),
    title: new FormControl(),
    step_id: new FormControl(),
    is_public: new FormControl(),
  });
  voucher = '';
  vatValue = 0;

  ngOnInit() {
    this.orderService.apiOrdersVatConfigGet().subscribe((res) => {
      if (res && res.success) {
        this.vatValue = res.data || 0;
      }
    });
    this.getAllAddress();
    this.getAllProductInCart();
  }
  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.changeDetectorRef.detach();
  }
  openModalChangeAddress() {
    var _this = this;
    const dialogRef = this.dialog.open(AppCartModalChangeAddressComponent, {
      data: {
        lstMyAddress: _this.lstMyAddress,
        checkedAddress: this.addressDefault,
      },
      width: '700px',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined) {
        if (result.event != undefined && result.event && result.addressOutput != null) {
          let indexAddressIsChoice = result.addressOutput.findIndex((x) => x.isChoosed == true);

          if (indexAddressIsChoice != -1) {
            this.addressId = result.addressOutput[indexAddressIsChoice].id;
          } else {
            this.addressId = '';
          }
          // for (let i = 0; i< result.addressOutput.length; i++){
          //   if (result.addressOutput[i].id == result.addressID){
          //     this.addressDefault = result.addressOutput[i];
          //   }
          // }
        }
      }
      this.getAllAddress();
    });
  }
  getAllAddress() {
    this.addressDefault = '';
    this.userService.apiUsersMyaddressGet().subscribe((res) => {
      if (res.success) {
        this.lstMyAddress = res.data;
        for (var i = 0; i < this.lstMyAddress.length; i++) {
          let parts = [];
          if (this.lstMyAddress[i].address) parts.push(this.lstMyAddress[i].address);
          if (this.lstMyAddress[i].ward) parts.push('phường ' + this.lstMyAddress[i].ward);
          if (this.lstMyAddress[i].district) parts.push('quận ' + this.lstMyAddress[i].district);
          if (this.lstMyAddress[i].province) parts.push(this.lstMyAddress[i].province);
          if (this.lstMyAddress[i].country) parts.push(this.lstMyAddress[i].country);
          this.lstMyAddress[i].fullAddress = parts.join(', ');
          if (this.lstMyAddress[i].id == this.addressId) {
            this.addressDefault = this.lstMyAddress[i];
            this.changeDetectorRef.detectChanges();
          }
        }
        if (this.addressDefault == '' && this.lstMyAddress.length > 0)
          this.addressDefault = this.lstMyAddress.find((element) => element.is_default == true);
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  getAllProductInCart() {
    this.cartProductService.apiMyCartProductsGet().subscribe((res) => {
      if (res.success == true) {
        this.lstProductCart = res.data.collection;
        this.addAll();
        for (let i = 0; i < this.lstProductCart.length; i++) {
          this.lstProductCart[i].extend_product.default_image =
            this.environment.backendhost + this.lstProductCart[i].extend_product.default_image;
          this.lstProductCart[i].seo_name = UtilService.slugify(
            this.lstProductCart[i].extend_product.name
          );
        }
        if (this.lstProductCart.length > 0) {
          const firstProductName = this.lstProductCart[0].extend_product.name;
          this.suggestionKeyword = firstProductName.split(' ').slice(0, 2).join(' ');
        } else {
          this.suggestionKeyword = '';
        }
        this.addAll();
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  submitStepOrder(order_id) {
    this.orderService.apiOrdersIdGet(order_id).subscribe((res) => {
      if (res.success) {
        this.subStepForm.patchValue({
          title: res.data.extend_step_name,
          order_id: res.data.id,
          step_id: res.data.step_id,
          is_public: true,
        });
        this.orderHistoryService
          .apiOrderHistoriesPost(this.subStepForm.value)
          .subscribe((resOH) => {});
      }
    });
  }
  orderProduct() {
    if (this.addressDefault == undefined || this.addressDefault == '') {
      this.openModalChangeAddress();
      return;
    }

    let lstProductOrder = [];
    let countProductCannotOrder = 0;
    this.lstProductCart.forEach((element) => {
      if (!element.quantity || element.quantity <= 0) {
        countProductCannotOrder++;
      }

      if (element.checked == true) {
        lstProductOrder.push({
          id: element.id,
          user_id: element.created_by,
          product_id: element.product_id,
          quantity: element.quantity,
          created_at: element.created_at,
          created_by: element.created_by,
          product_type_id: element.product_type_id,
          my_equipment_id: element.my_equipment_id || null,
          source_type: element.source_type || null,
          source_ref_id: element.source_ref_id || null,
          display_order: element.display_order || null,
        });
      }
    });

    if (countProductCannotOrder > 0) {
      this.toastr.warning(
        'Có ' + countProductCannotOrder + ' sản phẩm số lượng sản phẩm đặt không hợp lệ',
        'Vui lòng kiểm tra lại'
      );
      return;
    }
    if (lstProductOrder.length > 0) {
      this.vat = this.isPromotion ? this.getVAT() : null;
      this.orderService
        .apiOrdersPost(
          lstProductOrder,
          this.voucher,
          this.addressDefault.id,
          this.note,
          this.isPromotion ? true : false
        )
        .subscribe((res) => {
          if (res.success) {
            this.refreshCartAfterOrder();
            this.nextPageSuccess(res.data.extend_email, res.data.code);
            this.submitStepOrder(res.data.id);
            //this.addVoucherToOrder(res.data.id);
          }
        });
    } else {
      if (this.lstProductCart.length == 0) {
        this.toastr.warning('Giỏ hàng rỗng', 'Thao tác thất bại');
      } else {
        this.toastr.warning('Vui lòng chọn sản phẩm', 'Thao tác thất bại');
      }
    }
  }

  private refreshCartAfterOrder(): void {
    this.cartProductService.apiMyCartProductsGet().subscribe((reslst) => {
      if (reslst.success) {
        this.lstProductCart = reslst.data.collection || [];
        if (this.lstProductCart.length == 0) {
          $('.numberOfProduct').text('');
        } else {
          $('.numberOfProduct').text(this.lstProductCart.length);
        }
        this.calculateTotalMoney();
        this.changeDetectorRef.detectChanges();
      }
    });
  }
  sendQuote() {
    if (this.addressDefault == undefined || this.addressDefault == '') {
      this.openModalChangeAddress();
      return;
    }

    this.cartProductService
      .apiMyCartProductsExportPdfPost(
        this.addressDefault,
        this.isPromotion,
        this.voucherInfo ? this.voucherInfo.code : undefined
      )
      .subscribe(
        (blob: Blob) => {
          if (!blob || blob.size === 0) {
            this.toastr.error('Tải file chào giá thất bại', 'Thao tác thất bại');
            return;
          }

          // Read the beginning of the blob to determine if it is a PDF or a JSON message
          this.readBlobAsText(blob.slice(0, 1000))
            .then((txt) => {
              const isPdf = txt.startsWith('%PDF');

              if (isPdf) {
                // Trigger file download to prevent popup blocker issues
                const blobUrl = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = blobUrl;
                a.download = `chao-gia-${Date.now()}.pdf`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

                try {
                  const newWindow = window.open(blobUrl, '_blank');
                  if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
                    console.log('Popup blocker blocked new tab preview, file downloaded directly');
                  }
                } catch (e) {
                  console.error('Error opening new tab:', e);
                }

                setTimeout(() => window.URL.revokeObjectURL(blobUrl), 100);
                this.toastr.success('Tải chào giá thành công', 'Thành công');
                return;
              }

              // Otherwise it's a JSON response (like success message or error)
              try {
                const json = JSON.parse(txt);
                if (json && json.success) {
                  this.toastr.success(json.message || 'Gửi chào giá thành công', 'Thành công');

                  // If server returned a url in data
                  if (json.data && typeof json.data === 'string' && (json.data.startsWith('http') || json.data.startsWith('/'))) {
                    window.open(json.data, '_blank');
                  }
                } else if (json && json.message) {
                  this.toastr.error(json.message, 'Thao tác thất bại');
                } else {
                  this.toastr.error('Gửi chào giá thất bại', 'Thao tác thất bại');
                }
              } catch (e) {
                this.toastr.error('Gửi chào giá thất bại', 'Thao tác thất bại');
              }
            })
            .catch(() => {
              this.toastr.error('Lỗi khi đọc dữ liệu phản hồi', 'Lỗi');
            });
        },
        (err) => {
          let msg = 'Gửi chào giá thất bại';
          if (err && err.error && err.error.message) msg = err.error.message;
          this.toastr.error(msg, 'Thao tác thất bại');
        }
      );
  }

  private readBlobAsText(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      try {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          resolve(e.target.result as string);
        };
        reader.onerror = (err) => reject(err);
        reader.readAsText(blob);
      } catch (err) {
        reject(err);
      }
    });
  }
  addOrder(item, i) {
    this.quantityProductChecked = 0;
    this.lstProductCart.forEach((element) => {
      if (element.checked == true) {
        this.quantityProductChecked++;
        if (this.quantityProductChecked == this.lstProductCart.length) {
          this.checkAll = true;
        }
      }
    });
    this.calculateTotalMoney();
  }
  addAll() {
    this.quantityProductChecked = 0;
    this.lstProductCart.forEach((element) => {
      if (this.checkAll == true) {
        this.quantityProductChecked++;
        element.checked = true;
      } else {
        element.checked = false;
      }
    });
    this.calculateTotalMoney();
  }
  calculateTotalMoney() {
    let money = 0;
    let ship = 0;
    this.lstProductCart.forEach((element) => {
      if (element.checked == true) {
        money += element.extend_product.price * element.quantity;
        if (element.extend_product && element.extend_product.shipping_fee) {
          ship += Number(element.extend_product.shipping_fee) || 0;
        }
      }
    });
    this.provisionalMoney = money;
    this.shipMoney = ship;
    this.monePaid = this.provisionalMoney + (this.shipMoney || 0);
  }
  deleteProductCart(id, index) {
    const title = 'Xóa sản phẩm khỏi giỏ hàng của bạn';
    const description = 'Bạn có chắc chắn muốn xóa ?';
    const waitDesciption = 'Đang xử lý...';
    const dialogRef = this.layoutUtilsService.deleteElement(title, description, waitDesciption);
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      }
      this.cartProductService.apiMyCartProductsIdDelete(id).subscribe((res) => {
        if (res.success == true) {
          //this.getAllProductInCart();
          this.lstProductCart.splice(index, 1);
          this.lstProductCart = this.lstProductCart.slice();
          if (this.lstProductCart.length == 0) {
            $('.numberOfProduct').text('');
          } else {
            $('.numberOfProduct').text(this.lstProductCart.length);
          }
          this.addAll();
          this.calculateTotalMoney();
        }

        (error) => {
          this.toastr.error('Xóa thất bại', '');
        };
      });
    });
  }

  clearAllCart() {
    if (this.lstProductCart.length == 0) {
      return;
    }
    const title = 'Xóa tất cả sản phẩm trong giỏ hàng';
    const description = 'Bạn có chắc chắn muốn xóa toàn bộ sản phẩm trong giỏ hàng ?';
    const waitDesciption = 'Đang xử lý...';
    const dialogRef = this.layoutUtilsService.deleteElement(title, description, waitDesciption);
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      }
      const deleteRequests = this.lstProductCart.map((item) =>
        this.cartProductService.apiMyCartProductsIdDelete(item.id)
      );
      forkJoin(deleteRequests).subscribe(
        () => {
          this.lstProductCart = [];
          $('.numberOfProduct').text('');
          this.addAll();
          this.calculateTotalMoney();
          this.toastr.success('Đã xóa toàn bộ sản phẩm trong giỏ hàng', 'Thành công');
        },
        () => {
          this.toastr.error('Xóa giỏ hàng thất bại', '');
          this.getAllProductInCart();
        }
      );
    });
  }

  changeQuantity(event, i) {
    if (!event) {
      this.lstProductCart[i].quantity = 0;
    }
    setTimeout(() => {
      // if(this.lstProductCart[i].quantity>0){
      this.cartProductService
        .apiMyCartProductsIdPut(this.lstProductCart[i].id, this.lstProductCart[i])
        .subscribe((res) => {
          this.calculateTotalMoney();
        });
      // }
    }, 300);
  }

  updateQuantityProduct(type, i) {
    //debugger;

    switch (type) {
      case 'plus':
        // code block
        // if (this.lstProductCart[i].quantity >= this.lstProductCart[i].extend_product.quantity) {
        // 	return;
        // }

        // if (
        // 	this.lstProductCart[i].quantity <
        // 	this.lstProductCart[i].extend_product.quantity
        // ) {
        this.lstProductCart[i].quantity++;
        // } else {
        // 	this.lstProductCart[i].quantity = this.lstProductCart[
        // 		i
        // 	].quantity;
        // }
        break;
      case 'minus':
        // code block
        if (this.lstProductCart[i].quantity <= 1) {
          return;
        }

        // if (this.lstProductCart[i].quantity > 1) {
        this.lstProductCart[i].quantity--;
        // } else {
        // 	this.lstProductCart[i].quantity = 1;
        // }
        break;
    }
    this.cartProductService
      .apiMyCartProductsIdPut(this.lstProductCart[i].id, this.lstProductCart[i])
      .subscribe((res) => {
        this.calculateTotalMoney();
      });
  }

  nextPageSuccess(email, code) {
    this.router.navigate(['/order-success'], {
      queryParams: { email: email, code: code },
    });
  }
  selectProduct(productId, seoName) {
    this.router.navigate(['/product/' + productId + '/' + seoName + '/details']);
  }

  checkPromotion(event) {
    this.isPromotion = event.checked;
  }

  getVAT() {
    return this.isPromotion
      ? (this.vatValue / 100) *
          (this.provisionalMoney - (this.voucherInfo ? this.voucherInfo.value : 0))
      : 0;
  }

  openModalAddProduct() {
    const dialogRef = this.dialog.open(AppOrderDetailAddProductComponent, {
      data: {},
      width: '1200px',
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res && res.isAddProduct) {
        this.getAllProductInCart();
      }
    });
  }

  isAppliedVoucher = false;
  voucherInfo: any;
  selectVoucher() {
    this.voucherService.apiVouchersCodeGet(this.voucher).subscribe((res) => {
      if (res.success) {
        this.isAppliedVoucher = true;
        this.voucherInfo = res.data;
      } else {
        this.toastr.error(
          'chương trình khuyến mãi tương ứng không tồn tại.',
          'Mã giảm giá ' + this.voucher + ' không hợp lệ'
        );
      }
      this.changeDetectorRef.detectChanges();
    });
  }

  unSelectVoucher() {
    this.isAppliedVoucher = false;
    this.voucher = '';
    this.voucherInfo = null;
  }

  onDropProduct(event: CdkDragDrop<any[]>) {
    if (event.previousIndex === event.currentIndex) {
      return;
    }

    moveItemInArray(this.lstProductCart, event.previousIndex, event.currentIndex);

    const updateRequests = [];
    this.lstProductCart.forEach((item, index) => {
      const newOrder = index + 1;
      if (item.display_order !== newOrder) {
        item.display_order = newOrder;
        updateRequests.push(
          this.cartProductService.apiMyCartProductsIdPut(item.id, {
            ...item,
            display_order: newOrder
          })
        );
      }
    });

    if (updateRequests.length > 0) {
      forkJoin(updateRequests).subscribe(
        () => {},
        (error) => {
          this.toastr.error('Cập nhật thứ tự sản phẩm thất bại');
        }
      );
    }
  }
}
